import React from 'react';

const FerryIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='currentColor' fillRule='nonzero'>
      <g transform='translate(6.000000, 5.000000)'>
        <path d='M4,5 L16,5 L16,8.96 L10,7 L4,8.96 M1.94,18 L2,18 C3.6,18 5,17.12 6,16 C7,17.12 8.4,18 10,18 C11.6,18 13,17.12 14,16 C15,17.12 16.4,18 18,18 L18.05,18 L19.95,11.31 C20.03,11.06 20,10.78 19.89,10.54 C19.76,10.3 19.55,10.12 19.29,10.04 L18,9.62 L18,5 C18,3.89 17.1,3 16,3 L13,3 L13,0 L7,0 L7,3 L4,3 C2.8954305,3 2,3.8954305 2,5 L2,9.62 L0.71,10.04 C0.45,10.12 0.24,10.3 0.11,10.54 C-4.30211422e-16,10.78 -0.03,11.06 0.05,11.31 M18,20 C16.61,20 15.22,19.53 14,18.67 C11.56,20.38 8.44,20.38 6,18.67 C4.78,19.53 3.39,20 2,20 L0,20 L0,22 L2,22 C3.37,22 4.74,21.65 6,21 C8.5,22.3 11.5,22.3 14,21 C15.26,21.65 16.62,22 18,22 L20,22 L20,20 L18,20 Z' />
      </g>
    </g>
  </svg>
);

export default FerryIcon;
